/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiURL, prsCodes, convertDbTimestampToString } from '../../libs/utils'

export const fetchApps = createAsyncThunk('table/fetchApps', async (args, thunkAPI) => {
  thunkAPI.dispatch(fetchAppsStart())
  const {
    auth: { isAuthenticated },
  } = thunkAPI.getState()
  if (!isAuthenticated) {
    return thunkAPI.abort('not logged in')
  }
  try {
    const apiRes = await axios.post(apiURL, {
      ...args,
      prsCode: prsCodes.getApps,
    })
    const { data, status } = apiRes
    const rawResponse = data.responsePayload ? data.responsePayload : data
    if (status !== 200 || !Array.isArray(rawResponse)) {
      return thunkAPI.dispatch(
        fetchAppsFailure({
          name: 'Fetch request.',
          message: rawResponse.message || 'Failed to call getApplications API',
        })
      )
    }

    // fetching 20 quility apps
    // const quilityRes = await axios.post(apiURL, {
    //   ...args,
    //   prsCode: prsCodes.getQuilityApps,
    // })
    // const {
    //   data: { responsePayload: rawResponse2 },
    //   status: status2,
    // } = quilityRes
    // let quilityApps = []
    // if (status2 !== 200) {
    //   quilityApps = []
    // } else {
    //   quilityApps = rawResponse2.map((app) => ({
    //     ...app,
    //     status: listOfAppStatuses[app.appDecisionCode],
    //     appStatus: statusCompletions(app.appStatus),
    //     productName: listOfProducts[app.productId],
    //     applicationDate: convertDbTimestampToString(app.applicationDate),
    //   }))
    // }

    const apps = rawResponse.map((app) => ({
      ...app,
      status: listOfAppStatuses[app.appStatus],
      appStatus: statusCompletions(app.appStatus),
      productName: listOfProducts[app.productId],
      applicationDate: convertDbTimestampToString(app.applicationDate),
    }))
    // thunkAPI.dispatch(fetchAppsSuccess({ apps: apps.concat(quilityApps) }))
    thunkAPI.dispatch(fetchAppsSuccess({ apps }))
  } catch (error) {
    console.log('error', error)
    return thunkAPI.dispatch(fetchAppsFailure(error))
  }
})

export const fetchMetrics = createAsyncThunk('/table/fetchMetrics', async (args, thunkAPI) => {
  const {
    auth: { isAuthenticated },
  } = thunkAPI.getState()
  if (!isAuthenticated) {
    return thunkAPI.abort('not logged in')
  }
  try {
    const apiRes = await axios.post(apiURL, {
      ...args,
      prsCode: prsCodes.getMetrics,
    })
    const { data, status } = apiRes
    const rawResponse = data.responsePayload ? data.responsePayload : data
    if (status !== 200 || !Array.isArray(rawResponse.summarizedData)) {
      return thunkAPI.dispatch(
        fetchMetricsFailure({
          name: 'Fetch request.',
          message: rawResponse.msgText || 'Failed to call getMetricsData API',
        })
      )
    }
    const metricsList = rawResponse.summarizedData
    // console.log('metrics', metrics)
    thunkAPI.dispatch(fetchMetricsSuccess({ metricsList }))
  } catch (error) {
    console.log('error', error)
    return thunkAPI.dispatch(fetchMetricsFailure(error))
  }
})

export const fetchAgentProducts = createAsyncThunk('/table/fetchAgentProducts', async (args, thunkAPI) => {
  const {
    auth: { isAuthenticated },
  } = thunkAPI.getState()
  if (!isAuthenticated) {
    return thunkAPI.abort('not logged in')
  }
  try {
    const apiRes = await axios.post(apiURL, {
      ...args,
      prsCode: prsCodes.getAgentProducts,
    })
    const { data, status } = apiRes
    const rawResponse = data.responsePayload ? data.responsePayload : data
    if (status !== 200 || !Array.isArray(rawResponse)) {
      return thunkAPI.dispatch(
        fetchAgentProductsFailure({
          name: 'Fetch request.',
          message: rawResponse.message || 'Failed to call getMetricsData API',
        })
      )
    }
    const products = rawResponse.map(({ productId, productName, productUrl }) => ({
      productId,
      productName,
      productUrl,
    }))
    thunkAPI.dispatch(
      fetchAgentProductsSuccess({
        products,
      })
    )
  } catch (error) {
    console.log('error', error)
    return thunkAPI.dispatch(fetchAgentProductsFailure(error))
  }
})

export const fetchFactTableApps = createAsyncThunk('/table/fetchFactTableApps', async (args, thunkAPI) => {
  const {
    auth: { isAuthenticated },
  } = thunkAPI.getState()
  if (!isAuthenticated) {
    return thunkAPI.abort('not logged in')
  }
  try {
    const apiRes = await axios.post(apiURL, {
      ...args,
      prsCode: prsCodes.getFactTableApps,
    })
    const { data, status } = apiRes
    const rawResponse = data.responsePayload ? data.responsePayload : data
    if (status !== 200 || !Array.isArray(rawResponse.fact_table_applications)) {
      return thunkAPI.dispatch(
        fetchFactTableAppsFailure({
          name: 'Fetch request.',
          message: rawResponse.msgText || 'Failed to call getFactTableApps API',
        })
      )
    }
    // const dateCounter = rawResponse.fact_table_applications.reduce(
    //   (acc, curr) => {
    //     if (curr.applicationDate) {
    //       acc['hasDate']++
    //     }
    //     return acc
    //   },
    //   { hasDate: 0 }
    // )
    // console.log('dateCounter', dateCounter)
    const ftapps = rawResponse.fact_table_applications.map((app) => ({
      ...app,
      productName: listOfProducts[app.productId],
      appStatus: app.appStatus ? app.appStatus.trim() : 'Not Started',
      appAge: app.app_age,
      arcId: app.arcid,
    }))
    // const statuses = ftapps.reduce((acc, curr) => {
    //   if (!acc[curr.appStatus]) {
    //     acc[curr.appStatus] = 1
    //   } else {
    //     acc[curr.appStatus]++
    //   }
    //   return acc
    // }, {})
    // console.log('statuses v2', statuses)
    thunkAPI.dispatch(fetchFactTableAppsSuccess({ apps: ftapps }))
  } catch (error) {
    console.log('error', error)
    return thunkAPI.dispatch(fetchFactTableAppsFailure(error))
  }
})

export const fetchAgentList = createAsyncThunk('/table/fetchAgentList', async (args, thunkAPI) => {
  const {
    auth: { isAuthenticated },
  } = thunkAPI.getState()
  if (!isAuthenticated) {
    return thunkAPI.abort('not logged in')
  }
  try {
    const apiRes = await axios.post(apiURL, {
      ...args,
      prsCode: prsCodes.getAgentList,
    })
    const { data, status } = apiRes
    const rawResponse = data.responsePayload ? data.responsePayload : data
    if (status !== 200) {
      return thunkAPI.dispatch(
        fetchAgentListFailure({
          name: 'Fetch request.',
          message: rawResponse.msgText || 'Failed to call getAgentListAPI',
        })
      )
    }
    const agentList = rawResponse
    // console.log('metrics', metrics)
    thunkAPI.dispatch(fetchAgentListSuccess({ agentList }))
  } catch (error) {
    console.log('error', error)
    return thunkAPI.dispatch(fetchAgentListFailure(error))
  }
})

const tableSlice = createSlice({
  name: 'table',
  initialState: {
    loading: false,
    apps: [],
    metricsList: [],
    agentList: [],
    factTableApps: [],
    agentProducts: [],
    getAppsError: null,
    getMetricsError: null,
    getFactTableAppsError: null,
    getAgentProductsError: null,
  },
  reducers: {
    fetchAppsStart: (state, payload) => {
      state.loading = true
    },
    fetchAppsSuccess: (state, { payload: { apps } }) => {
      state.loading = false
      state.apps = apps
    },
    fetchAppsFailure: (state, action) => {
      state.loading = false
      state.apps = []
      const errorObj = action.payload
      state.getAppsError = {
        name: errorObj.name,
        message: errorObj.message,
      }
    },
    fetchMetricsSuccess: (state, { payload: { metricsList } }) => {
      state.metricsList = metricsList
    },
    fetchAgentListSuccess: (state, { payload: { agentList } }) => {
      state.agentList = agentList
    },
    fetchFactTableAppsSuccess: (state, { payload: { apps } }) => {
      state.loading = false
      state.factTableApps = apps
    },
    fetchAgentProductsSuccess: (state, { payload: { products } }) => {
      state.agentProducts = products
    },
    fetchMetricsFailure: (state, action) => {
      state.metricsList = []
      const errorObj = action.payload
      state.getMetricsError = {
        name: errorObj.name,
        message: errorObj.message,
      }
    },
    fetchAgentProductsFailure: (state, action) => {
      state.agentProducts = []
      const errorObj = action.payload
      state.getAgentProductsError = {
        name: errorObj.name,
        message: errorObj.message,
      }
    },
    fetchFactTableAppsFailure: (state, action) => {
      state.loading = false
      state.factTableApps = []
      const errorObj = action.payload
      state.getFactTableAppsError = {
        name: errorObj.name,
        message: errorObj.message,
      }
    },
    fetchAgentListFailure: (state, action) => {
      state.agentList = []
      const errorObj = action.payload
      state.getMetricsError = {
        name: errorObj.name,
        message: errorObj.message,
      }
    },
  },
})

const {
  fetchMetricsFailure,
  fetchMetricsSuccess,
  fetchAgentListSuccess,
  fetchAppsStart,
  fetchAppsSuccess,
  fetchAppsFailure,
  fetchFactTableAppsFailure,
  fetchFactTableAppsSuccess,
  fetchAgentProductsFailure,
  fetchAgentProductsSuccess,
  fetchAgentListFailure,
} = tableSlice.actions

export const loadingSelector = (state) => state.table.loading
const appsSelector = (state) => state.table.apps
const metricsSelector = (state) => state.table.metricsList
const agentsSelector = (state) => state.table.agentList
const factTableAppsSelector = (state) => state.table.factTableApps
const agentProductsSelector = (state) => state.table.agentProducts
const getAppsErrorSelector = (state) => state.table.getAppsError
const getFactTableAppsErrorSelector = (state) => state.table.getFactTableAppsError
const getMetricsErrorSelector = (state) => state.table.getMetricsError
const getAgentProductsErrorSelector = (state) => state.table.getAgentProductsError
export const appsBlobSelector = createSelector(appsSelector, getAppsErrorSelector, (apps, appsError) => ({
  apps,
  appsError,
}))
export const productsBlobSelector = createSelector(
  agentProductsSelector,
  getAgentProductsErrorSelector,
  (products, getAgentProductsError) => ({
    products,
    getAgentProductsError,
  })
)
export const factTableAppsBlobSelector = createSelector(
  factTableAppsSelector,
  getFactTableAppsErrorSelector,
  (factTableApps, factTableAppsError) => ({
    factTableApps,
    factTableAppsError,
  })
)
export const metricsListSelector = createSelector(
  metricsSelector,
  getMetricsErrorSelector,
  (metricsList, metricsError) => ({
    metricsList,
    metricsError,
  })
)

export const agentListSelector = createSelector(agentsSelector, (agentList) => ({
  agentList,
}))
export default tableSlice.reducer

const listOfAppStatuses = {
  1: 'Policy Submitted',
  2: 'Declined',
  3: 'MIB Pending',
  4: 'KO Declined',
  5: 'ID Check Failed',
  6: 'Applicant Not Eligible',
  7: 'Application Expired',
  10: 'RUW',
  11: 'Expired',
  null: 'Incomplete',
  // 0: 'Invalid request',
  // 1: 'Approved',
  // 2: 'Declined',
  // 3: 'MIB Pending',
  // 4: 'Declined due to UW questions',
  // 5: 'Incomplete',
  // 6: '3rd party insufficient',
  // 7: 'ID check failed',
  // 9: 'System issues',
  // 10: 'Disqualified',
  // 99: 'Decision not ready, call back',
}
const statusCompletions = (num) => {
  num = String(num)
  switch (num) {
    case '1':
      return 'Submitted'
    case '2':
    case '4':
    case '6':
    case '7':
      return 'Completed'
    case '3':
    case '5':
    case 'null':
    case '10':
      return 'In Progress'
    case '11':
      return 'Expired'
    default:
      return 'Not Started'
  }
}

const listOfProducts = {
  8113: 'Accidental Death',
  8118: 'Quility Secure Future Select',
  8140: 'Quility Level Term',
  8142: 'Quility Level Term Return of Premium',
  81401: 'Quility Level Term',
  81403: 'Assure Level Term'
}
